class MockResizeObserver {
  observe() {// do nothing
  }

  unobserve() {// do nothing
  }

  disconnect() {// do nothing
  }

}

export default MockResizeObserver;